// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ---------------- Card Base ---------------- */
.gradebookCard {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border: 1px solid rgba(102, 126, 234, 0.15) !important;
  border-radius: 16px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06) !important;
  transition: 0.3s ease;
  min-height: 345px; /* same height */
}

.gradebookCard:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;
}

.gradebookCard .ant-card-body {
  padding: 24px !important;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

/* ---------------- Card Header ---------------- */
.gradebookCardHeader {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
  margin-bottom: 16px;
}

.gradebookCardIconWrapper {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.15), rgba(118, 75, 162, 0.15));
  display: flex;
  justify-content: center;
  align-items: center;
}

.gradebookCardIcon {
  font-size: 26px !important;
  color: #667eea !important;
}

.gradebookCardTitle {
  font-size: 20px;
  font-weight: 700;
  margin: 0;
  color: #1f2937;
}

/* ---------------- Card Content ---------------- */
.gradebookCardContent {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex-grow: 1;
}

/* Label & Number Row (like leaderboard) */
.statusRow {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 4px 0;
}

.statusLabel {
  font-size: 13px;
  color: #6b7280; /* light grey like leaderboard */
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.statusValue {
  font-size: 20px;
  font-weight: 700;
  color: #667eea; /* violet like leaderboard */
  margin-left: 8px;
}

/* Tag Row */
.tagRow {
  margin: 8px 0;
  display: flex;
  gap: 10px;
}

.statusTag {
  font-size: 15px;
  padding: 3px 10px;
  border-radius: 6px;
  font-weight: 600;
}

/* Next Step at bottom */
.nextStep {
  margin-top: 12px;
  padding: 12px;
  border-radius: 10px;
  background: rgba(102, 126, 234, 0.05);
  font-weight: 500;
  font-size: 15px;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* ---------------- Progress Bar ---------------- */
.ant-progress-bg {
  border-radius: 8px !important;
  height: 12px !important;
  background: linear-gradient(90deg, #667eea, #764ba2) !important; /* violet gradient */
}

/* Progress Wrapper ensures vertical alignment */
.gradebookCardContent .progressWrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1;
}

.gradientText {
  /* Fallback color for unsupported browsers */
  color: #667eea;

  /* Gradient text */
  background: linear-gradient(90deg, #667eea, #764ba2);
  -webkit-background-clip: text; /* Chrome, Safari */
  -webkit-text-fill-color: transparent; /* Chrome, Safari */
  background-clip: text; /* Standard (may not work in Firefox) */
}



`, "",{"version":3,"sources":["webpack://./src/Components/Dashboard/StatusCard.css"],"names":[],"mappings":"AAAA,gDAAgD;AAChD;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,sDAAsD;EACtD,8BAA8B;EAC9B,qDAAqD;EACrD,qBAAqB;EACrB,iBAAiB,EAAE,gBAAgB;AACrC;;AAEA;EACE,2BAA2B;EAC3B,qDAAqD;AACvD;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,wFAAwF;EACxF,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,cAAc;AAChB;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc,EAAE,gCAAgC;EAChD,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc,EAAE,4BAA4B;EAC5C,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,mDAAmD;AACnD;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,+DAA+D,EAAE,oBAAoB;AACvF;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,4CAA4C;EAC5C,cAAc;;EAEd,kBAAkB;EAClB,oDAAoD;EACpD,6BAA6B,EAAE,mBAAmB;EAClD,oCAAoC,EAAE,mBAAmB;EACzD,qBAAqB,EAAE,uCAAuC;AAChE","sourcesContent":["/* ---------------- Card Base ---------------- */\n.gradebookCard {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  border: 1px solid rgba(102, 126, 234, 0.15) !important;\n  border-radius: 16px !important;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06) !important;\n  transition: 0.3s ease;\n  min-height: 345px; /* same height */\n}\n\n.gradebookCard:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;\n}\n\n.gradebookCard .ant-card-body {\n  padding: 24px !important;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n/* ---------------- Card Header ---------------- */\n.gradebookCardHeader {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.07);\n  margin-bottom: 16px;\n}\n\n.gradebookCardIconWrapper {\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  background: linear-gradient(135deg, rgba(102, 126, 234, 0.15), rgba(118, 75, 162, 0.15));\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.gradebookCardIcon {\n  font-size: 26px !important;\n  color: #667eea !important;\n}\n\n.gradebookCardTitle {\n  font-size: 20px;\n  font-weight: 700;\n  margin: 0;\n  color: #1f2937;\n}\n\n/* ---------------- Card Content ---------------- */\n.gradebookCardContent {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  flex-grow: 1;\n}\n\n/* Label & Number Row (like leaderboard) */\n.statusRow {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 4px 0;\n}\n\n.statusLabel {\n  font-size: 13px;\n  color: #6b7280; /* light grey like leaderboard */\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.statusValue {\n  font-size: 20px;\n  font-weight: 700;\n  color: #667eea; /* violet like leaderboard */\n  margin-left: 8px;\n}\n\n/* Tag Row */\n.tagRow {\n  margin: 8px 0;\n  display: flex;\n  gap: 10px;\n}\n\n.statusTag {\n  font-size: 15px;\n  padding: 3px 10px;\n  border-radius: 6px;\n  font-weight: 600;\n}\n\n/* Next Step at bottom */\n.nextStep {\n  margin-top: 12px;\n  padding: 12px;\n  border-radius: 10px;\n  background: rgba(102, 126, 234, 0.05);\n  font-weight: 500;\n  font-size: 15px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* ---------------- Progress Bar ---------------- */\n.ant-progress-bg {\n  border-radius: 8px !important;\n  height: 12px !important;\n  background: linear-gradient(90deg, #667eea, #764ba2) !important; /* violet gradient */\n}\n\n/* Progress Wrapper ensures vertical alignment */\n.gradebookCardContent .progressWrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  flex-grow: 1;\n}\n\n.gradientText {\n  /* Fallback color for unsupported browsers */\n  color: #667eea;\n\n  /* Gradient text */\n  background: linear-gradient(90deg, #667eea, #764ba2);\n  -webkit-background-clip: text; /* Chrome, Safari */\n  -webkit-text-fill-color: transparent; /* Chrome, Safari */\n  background-clip: text; /* Standard (may not work in Firefox) */\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
